import { useSearchProducts } from '../../../../api/products/useSearchProducts';
import { PRICE_INCREMENT } from './getSearchPriceRange';

interface UseGlobalPriceRange {
  min: number;
  max: number;
  isLoading: boolean;
}

export const useGlobalPriceRange = (): UseGlobalPriceRange => {
  const { data: products, isLoading: isLoadingProducts } = useSearchProducts();

  const prices = products.map((product) => product.content.msrp).filter((p): p is number => p !== undefined);

  const globalMin = prices.length ? Math.floor(Math.min(...prices) / PRICE_INCREMENT) * PRICE_INCREMENT : 0;
  const globalMax = prices.length ? Math.ceil(Math.max(...prices) / PRICE_INCREMENT) * PRICE_INCREMENT : 0;
  return { min: globalMin, max: globalMax, isLoading: isLoadingProducts };
};
